export default class MonitoramentoAtividade {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.projetoId = 0;
        this.data = '';
        this.avaliacao = '';
        this.itens = [];

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.projetoId = model.projetoId;
        this.projeto = model.projeto;
        this.data = new Date(model.data).yyyymmdd();
        this.avaliacao = model.avaliacao;
        this.itens = model.itens;
    }
}